<template>
  <b-modal  scrollable v-model="show" centered :title="'Anhänge anfügen'">
    <b-row>
      <b-col>
        <span>Zum Einfügen in das Feld klicken</span>
        <vue-dropzone v-on:vdropzone-error="log" ref="drop" id="drop" :options="dropOptions" style="max-height: 45vh; overflow: auto; padding: 8px"></vue-dropzone>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave">
        Hochladen
      </b-button>
    </template>
  </b-modal>
</template>

<script>


import vueDropzone from "vue2-dropzone";
export default {
  name: "TaskAttachmentUpload",
  props:{
  },
  components: {
    vueDropzone,
  },
  data() {
    return {
      show: false,
      dropOptions: {
        url: "https://httpbin.org/post",
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictDefaultMessage: "<i class='icon-cloud-upload icon font-4xl mr-3 mt-3'></i>",
        dictRemoveFile: "Entfernen",
        maxFilesize: 5,
        dictFileTooBig: "Die Datei ist zu groß ({{filesize}}MB). Maximale Dateigröße: {{maxFilesize}}MB",
      },

    }
  },
  computed: {
  },
  methods: {
    log(file, message, xhr) {
      this.$refs.drop.removeFile(file);
      this.$bvToast.toast(message, {
        title: 'Dateifehler',
        autoHideDelay: 3000,
        appendToast: false,
        toaster: 'b-toaster-top-center',
      })
    },
    onSave() {
      this.show = false;
      this.$emit("upload-files", this.$refs.drop.getQueuedFiles());
      this.$refs.drop.removeAllFiles();
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      if (this.$refs.drop) {
        this.$refs.drop.removeAllFiles();
      }
      this.show = true;
    },
  }
}
</script>

<style scoped>
</style>
